export const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ align: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean'],
  ],
};

export const quillFormats = [
  'bold',
  'italic',
  'underline',
  'strike',
  'align',
  'list',
];
